import React from "react";
import { connect } from "react-redux";

import { useI18n, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelecaoCheckboxBase from "../../../../comum/SelecaoCheckboxBase";

import {
  type ActionCreator,
  getFrequenciasSelecionadas,
  getFrequenciasDisponiveis,
  selecionarFrequencias,
} from "../../../../../state";
import { type Id } from "../../../../../model";

type Props = {
  listaFrequencias: Array<TipoCalculo>,
  frequenciasSelecionadas: Id,
  selecionarFrequencias: ActionCreator,
};

const SelecaoFrequencia = ({
  listaFrequencias,
  frequenciasSelecionadas,
  selecionarFrequencias,
}: Props) => {
  const { translate } = useI18n();

  const onChangeFrequencias = ids => selecionarFrequencias(ids);

  return (
    <div className="ConfiguracaoMedida">
      <SelecaoCheckboxBase
        nomeSelecao={translate("ConfiguracaoIndicador.frequenciaIndicador")}
        itens={listaFrequencias}
        itensSelecionados={frequenciasSelecionadas}
        onChange={onChangeFrequencias}
        campoId="codigo"
        campoDescricao="traducao"
      />
    </div>
  );
};

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaFrequencias: getFrequenciasDisponiveis(state).map(frequencia => ({
        ...frequencia,
        traducao: ownProps.translate(frequencia.descricao),
      })),
      frequenciasSelecionadas: getFrequenciasSelecionadas(state),
    }),
    {
      selecionarFrequencias,
    }
  )
)(SelecaoFrequencia);
